import type {RentalResourceCalendarEvent} from '../types/RentalResourceCalendarEvent';

/**
 * Keeps the events whose interval intersects the visible range (boundary touches included),
 * so multi-day rentals reaching into the range from either side stay rendered.
 */
export function filterEventsForRange(
  events: RentalResourceCalendarEvent[],
  rangeStart: Date,
  rangeEnd: Date
) {
  return events.filter((event) => event.start <= rangeEnd && event.end >= rangeStart);
}
